export const ERROR_RUNTIME: string = "runtime.exception";
export const ERROR_PASSWORD_USED_BEFORE: string = "pwd.usedBefore";
export const ERROR_INVALID_OLD_PASS: string = "pwd.current.incorrect";
export const ERROR_LENGTH_INVALID: string = "pwd.length.invalid";

export const OLD_PASS_ERRORS: Array<string> = [ERROR_INVALID_OLD_PASS];
export const SYSTEM_ERRORS: Array<string> = [
  ERROR_RUNTIME,
  ERROR_PASSWORD_USED_BEFORE,
  ERROR_LENGTH_INVALID,
];

export const MINIMUM_PASSWORD_LENGTH: number = 4;
export const MAXIMUM_PASSWORD_LENGTH: number = 30;
export const MINIMUM_PASSWORD_LENGTH_SYSCONF: string = "pwd.req.minLength";
export const MAXIMUM_PASSWORD_LENGTH_SYSCONF: string = "pwd.req.maxLength";

export const STRENGTH_MESSAGES: Array<string> = ["Low", "Medium", "High", "Very high"];
export const STRENGTH_COLORS: Array<string> = [
  "low-strength",
  "medium-strength",
  "high-strength",
  "very-high-strength",
];
